import React from 'react';

const SubscriptionContext = React.createContext({
  isReady: false,
  subscription: null,
});

export default SubscriptionContext;
